// Clinic Configuration for Meadows Dental Care
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Meadows Dental Care",
  clinicId: "meadowsdentalcare",
  clinicUrl: "https://themeadowsdentalcare.com",
  // Contact Information
  phoneNumber: "737-263-1581",
  phoneNumberRaw: "+17372631581", // For tel: and sms: links
  email: "dentist@themeadowsdentalcare.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=meadowsdentalcare&agentId=617de739-29e3-4065-8c65-623f546d8244",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/meadowsdentalcare/voice",

  // Location
  address: "9600 S I-35 Frontage Rd Bldg S #275, Austin, TX 78748, United States",
  addressShort: "9600 S I-35 Frontage Rd Bldg S #275, Austin, TX 78748",
  city: "Austin",
  hcity: "Austin",
  state: "Texas",
  stateShortForm: "TX",
  zipCode: "78748",
  PostalCode: "78748",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/Hz4S86nieDoEJyZi6",
  googleMapsLink: "https://maps.app.goo.gl/Hz4S86nieDoEJyZi6",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d110391.80274745333!2d-97.790959!3d30.158739!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865b4cd65b6356f5%3A0xd2c305273fcbbc82!2sMeadows%20Dental%20Care%20%26%20Orthodontics!5e0!3m2!1sen!2sin!4v1756797635853!5m2!1sen!2sin',
  iframeTitle: "Meadows Dental Care",

  //membership
  membership: "https://member.kleer.com/?slug=UN2K",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalPartners-MeadowsDentalCare",

  // Cherry
  cherryUrl: "https://themeadowsdentalcare.com/patient-portal",

  // Analytics
  gaMeasurementId: "G-D9JGSV807V",
  clarityProjectId: "q5nl2vx1uk",

  // Google Ads — direct conversion tracking
  googleAdsId: "AW-11552813086",
  googleAdsConversions: {
    // Primary — used for Smart Bidding optimization
    "phone_call_click": "AW-11552813086/Q0ZhCKmqzZQcEJ7g54Qr",
    "contact_form_success": "AW-11552813086/HM8FCLe0roYcEJ7g54Qr",
    "call_back_success": "AW-11552813086/3PEtCI20roYcEJ7g54Qr",
    "chatbot_phone_click": "AW-11552813086/Fs7lCNL-w5QcEJ7g54Qr",
    "chatbot_voice_call": "AW-11552813086/cjFyCMqqzZQcEJ7g54Qr",
    "book_appointment_success": "AW-11552813086/2wUACKyet4YcEJ7g54Qr",
    "Confirm-Booking": "AW-11552813086/0nLKCP6rzZQcEJ7g54Qr",
    "Submit-Payment": "AW-11552813086/DBJGCLKCxJQcEJ7g54Qr",
    // Secondary — observation/reporting only
    "sms_click": "AW-11552813086/EF-lCMKDxJQcEJ7g54Qr",
    "directions_click": "AW-11552813086/5JRqCMWDxJQcEJ7g54Qr",
    "email_click": "AW-11552813086/xKyOCJKXuJQcEJ7g54Qr",
    "map_click": "AW-11552813086/8oH_CLCXuJQcEJ7g54Qr",
    "social_media_click": "AW-11552813086/2zfbCPGtzZQcEJ7g54Qr",
    "financing_click": "AW-11552813086/cFp7CKGlzZQcEJ7g54Qr",
    "membership_click": "AW-11552813086/1j3BCIGpzZQcEJ7g54Qr",
    "outbound_link_click": "AW-11552813086/-NkCCMmYuJQcEJ7g54Qr",
    "chat_send": "AW-11552813086/GimECPStzZQcEJ7g54Qr",
    "chatbot_quick_action": "AW-11552813086/2MnZCK-SzZQcEJ7g54Qr",
    "chatbot_insurance_upload": "AW-11552813086/DY60CKiszZQcEJ7g54Qr",
  } as Record<string, string>,

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/meadowsdentalcare",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/meadowsdentalcare",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/meadowsdentalcare",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://themeadowsdentalcare.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/meadowsdentalcaretx",
    instagram: "https://www.instagram.com/stories/meadows_dentalcare/",
    twitter: "https://x.com/meadows_dent",
    linkedin: "https://www.linkedin.com/company/the-meadows-dental-care/",
    youtube: "https://www.youtube.com/@TheMeadowsDentalCare",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/3212159561455542358/profile?hl=en-GB&fid=15186988034555624578",
    facebook: "https://www.facebook.com/themeadowsdentalcare/",
    yelp: "https://www.yelp.com/biz/meadows-dental-care-austin",
  },

  // Open Dental Configuration
  defaultProvNum: 199,
  defaultOpNum: 6578,

  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 6579,
      AppointmentTypeNum: 10
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 6578,
      AppointmentTypeNum: 9
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 6578,
      AppointmentTypeNum: 5
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "17373177267",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  zipCode,
  mapUrl,
  googleMapsLink,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
